import { createApiSlice } from "@common";
import { CRUD_SALES_REGION } from "@routes";

const apiConfig = [
  {
    name: "addSalesRegion",
    method: "post",
    url: CRUD_SALES_REGION,
    stateKey: "message",
  },
  {
    name: "getSalesRegion",
    method: "get",
    url: CRUD_SALES_REGION,
    stateKey: "data",
  },
  {
    name: "updateSalesRegion",
    method: "put",
    url: CRUD_SALES_REGION,
    stateKey: "message",
  },
  {
    name: "deleteSalesRegion",
    method: "delete",
    url: CRUD_SALES_REGION,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"salesRegion",
 apiConfig, 
 customReducers);
const salesRegionSlice = slice;

export default salesRegionSlice.reducer;

export const {
  addSalesRegion,
  getSalesRegion,
  updateSalesRegion,
  deleteSalesRegion,
} = thunks;

export const { rowSelect } = actions;
